export const tableHeaderStyles = {
  backgroundColor: "#e4eee9",
  color: "#245c50",
};
